import { SVGProps } from "react";

export function CompanyIcon({
  stroke = "#667085",
  fill = "#667085",
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={18}
      height={19}
      viewBox="0 0 18 19"
      fill="none"
      xmlns={xmlns}
      {...props}
    >
      <path 
        d="M16.5 16.3955H1.5" 
        stroke={stroke} 
        strokeWidth="1.25" 
        strokeLinecap="round"
        strokeLinejoin="round" 
      />
      <path
        d="M12.75 10.3955H14.25C14.6642 10.3955 15 10.7313 15 11.1455V15.6455C15 16.0597 14.6642 16.3955 14.25 16.3955H12.75C12.3358 16.3955 12 16.0597 12 15.6455V11.1455C12 10.7313 12.3358 10.3955 12.75 10.3955Z"
        stroke={stroke} 
        strokeWidth="1.25" 
        strokeLinejoin="round" 
      />
      <path 
        d="M13.5 13.3955H13.125" 
        stroke={stroke} 
        strokeWidth="1.25" 
        strokeLinecap="square"
        strokeLinejoin="round" 
      />
      <path
        d="M3.75 2.14551H11.25C11.6642 2.14551 12 2.48129 12 2.89551V15.6455C12 16.0597 11.6642 16.3955 11.25 16.3955H3.75C3.33579 16.3955 3 16.0597 3 15.6455V2.89551C3 2.48129 3.33579 2.14551 3.75 2.14551Z"
        stroke={stroke} 
        strokeWidth="1.25" 
        strokeLinejoin="round" 
      />
      <path
        d="M9.75 4.39551H8.25V5.89551H9.75V4.39551ZM6.75 4.39551H5.25V5.89551H6.75V4.39551ZM9.75 7.02051H8.25V8.52051H9.75V7.02051ZM6.75 7.02051H5.25V8.52051H6.75V7.02051ZM6.75 9.64551H5.25V11.1455H6.75V9.64551ZM6.75 12.2705H5.25V13.7705H6.75V12.2705Z"
        fill={fill} 
      />
    </svg>
  );
}
